import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import RoleEditor from './EditorPages/RoleEditor';
import RoleResults from './ResultsPages/RoleResults';

function Communities({
    urlParams
}) {
    const queryParams = queryString.parse(urlParams);

    return (
        queryParams && queryParams['id'] ?
            <RoleEditor id={queryParams['id']} /> :
            <RoleResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(Communities);